import { Infobox } from 'ui/components';

export const InfoboxFeature: React.FC<Content.Infobox> = ({ content}) => {
    return (
        <Infobox {...content?.properties} />
)};